import { initializeApp } from "firebase/app";

const firebaseConfig = {
apiKey: "AIzaSyAAaEqXJu1hSSY3maV6xZfGJE2LItmwS5A",
authDomain: "masajista-masculino.firebaseapp.com",
projectId: "masajista-masculino",
storageBucket: "masajista-masculino.firebasestorage.app",
messagingSenderId: "851453952391",
appId: "1:851453952391:web:99b043fc489bf8d8e15322"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export default app;